import React, { FC } from 'react';
import { useBiSessionContext } from '@components/Contexts/BiSessionContext';
import Header from '@components/Header';

const TemplatePageHeader: FC = () => {
  const { sessionId } = useBiSessionContext();

  return (
    <Header onClick={() => {}} pageName="template page" sessionId={sessionId} />
  );
};

export default TemplatePageHeader;
